import { useTranslation } from "react-i18next";
import { SnaphotApi as SnaphotApiProd } from "../services/akfenservicesprod/api";
import { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { Line } from "react-chartjs-2";
import moment from "moment";

function PricePerformance() {
  //#region API
  const snaphotProdApi = new SnaphotApiProd({
    username: "akfeninsaat-avocet",
    password: "G*W8Cc/k?zK&Pp9",
  });

  let api = snaphotProdApi;

  //#endregion

  //#region Page Property
  const { t, i18n } = useTranslation();
  const chartRef = useRef();
  //#endregion

  //#region Frequencies
  const frequencies = [
    { value: "1w", label: t("weekly") },
    { value: "1m", label: t("month") },
    { value: "3m", label: t("month") },
    { value: "6m", label: t("month") },
    { value: "1y", label: "1y" },
    { value: "2y", label: "2y" },
    { value: "3y", label: "3y" },
    { value: "5y", label: "5y" },
  ];
  //#endregion

  //#region UseState
 
  const [frequency, setFrequency] = useState("1y");
  const [chartStatu, setChartStatu] = useState(true);
  const [priceGridData, setPriceGridData] = useState([]);
  const [selectedLang, setSelectedLang] = useState("");
  

  const [chartData, setChartData] = useState({
    datasets: [
      {
        fill: false,
        borderColor: "#E1E2E2",
        borderWidth: 1,
        pointRadius: 0,
      },
    ],
  });

  const [chartOptions, setChartOptions] = useState({
     maintainAspectRatio: false,
  responsive: true,
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        intersect: false,
        mode: "index",
      },
    },
    scales: {
      x: {
        type: "time",
        distribution: "linear",
        grid: {
          display: false,
        },
        ticks: {
          font: {
            color: "#000",
            size: 13,
          },
        },
        time: {
          unit: "month",
        },
      },
      y: {
        
        grid: {
          color: "#E1E2E2",
        },
        ticks: {
          font: {
            color: "#000",
            size: 12,
          },
          padding: 15,
        },
        beginAtZero: true,
      },
    },
  });


  //#endregion

  //#region Format Number
  const formatNumber = (number) => {
    return number.toLocaleString("en-US", {
      style: "decimal",
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  };
  //#endregion

  //#region Load Data

  const priceChartData = (frequency) => {
    let fr = "OneYear";
    if (frequency !== undefined && frequency !== null && frequency !== "") {
      if (frequency === "1w") fr = "OneWeek";
      else if (frequency === "1m") fr = "OneMonth";
      else if (frequency === "3m") fr = "ThreeMonth";
      else if (frequency === "6m") fr = "SixMonth";
      else if (frequency === "1y") fr = "OneYear";
      else if (frequency === "2y") fr = "TwoYear";
      else if (frequency === "3y") fr = "ThreeYear";
      else if (frequency === "5y") fr = "FiveYear";
    }

    if (api !== undefined && api !== "") {
      api.snaphotPriceChartGet("sec.101.837", fr).then((response) => {
        if (response.status === 200) {
          let datas = response.data;
          let data1 = [];
          let label = [];

          for (var i = 0; i < datas.length; i++) {
            data1.push(parseFloat(datas[i]["value"]).toFixed(2));
            label.push(
              moment(
                new Date(datas[i]["date"].toString().split("T")[0])
              ).format("yyyy-MM-DD")
            );
          }

          const newChartData = {
            labels: label,
            datasets: [
              {
                data: data1,
                fill: false,
                borderColor: "#1DFF00",
                borderWidth: 1,
                pointRadius: 0,
              },
            ],
          };

          setChartData(newChartData);
          setPriceGridData(datas);
        }
      });
    }
  };

  //#endregion

  //#region Other Function
  const frequencyFunction = (e, fr) => {
    setFrequency(fr);

    let items = document.querySelectorAll("#chart-dates .list-inline-item");
    items.forEach((s) => {
      if (s.childNodes[0].classList.contains("selected")) {
        s.childNodes[0].classList.remove("selected");
      }
    });
    e.target.classList.add("selected");
  };

  //#endregion


  //#region UseEffect
  useEffect(() => {
    if (window.location.pathname.indexOf("priceperformance") !== -1) {
      i18n.changeLanguage("en");     
      setSelectedLang("en-US");         
    } else {     
      setSelectedLang("tr-TR");     
    }
  }, []);

  useEffect(() => {
    priceChartData(frequency);
  }, [frequency]);
  
    useEffect(() => {
    if (selectedLang !== "") {
    
      setChartOptions({
        plugins: {
          legend: {
            display: false,
          },
          tooltip: {
            intersect: false,
            mode: "index",
            callbacks: {
              label: (tooltipItem) => {
                if (selectedLang === "tr-TR") {
                  return formatNumber(tooltipItem.raw, 2, selectedLang);
                } else {
                  return (
                    formatNumber(tooltipItem.raw, 2, selectedLang)
                  );
                }
              },
              title: (tooltipItems) => {
                const date = new Date(tooltipItems[0].parsed.x);
                if (selectedLang === "tr-TR") {
                  return new Intl.DateTimeFormat("tr-TR", {
                    year: "numeric",
                    month: "long",
                    day: "numeric",
                  }).format(date);
                } else {
                  return new Intl.DateTimeFormat("en-US", {
                    year: "numeric",
                    month: "long",
                    day: "numeric",
                  }).format(date);
                }
              },
            },
          },
        },
        scales: {
          x: {
            type: "time",
            distribution: "linear",
            grid: {
              display: false,
            },
            ticks: {
              callback: (value, index, ticks) => {
                const date = new Date(value);
                if (selectedLang === "tr-TR") {
                  return new Intl.DateTimeFormat("tr-TR", {
                    year: "numeric",
                    month: "short",
                  }).format(date);
                } else {
                  return new Intl.DateTimeFormat("en-US", {
                    year: "numeric",
                    month: "short",
                  }).format(date);
                }
              },
              font: {
                color: "#000",
                size: 13,
              },
            },
            time: {
              unit: "month",
            },
          },
          y: {
            beginAtZero: true,
            grid: {
              color: "#E1E2E2",
            },
            ticks: {
              callback: function (value, index, ticks) {
                return formatNumber(value, 2, selectedLang);
              },
              font: {
                color: "#000000",
                weight: 'bold',
                size: 12,
              
              },
              padding: 15,
            }
          },
        },
      });
    }
  }, [selectedLang]);
  //#endregion

  return (
    <div className="pricePerformance">
      <div className="row mb-2">
        <div className="col-12">
          <div className="row">
            <div className="col-12">
              <div className="title mb-4">
                {t("pricePerformance")}
                <i
                  className="fa fa-th float-end"
                  onClick={() => setChartStatu(!chartStatu)}
                ></i>
              </div>
              <div className="chartArea">
                <div className={`row ${chartStatu ? "" : "d-none"}`}>
                  <div className="col-md-12 text-end rt-item">
                    <ul
                      id="chart-dates"
                      className="list-inline m-0 chart-period-btn mb-3"
                    >
                      {frequencies.map(({ value, label }) => (
                        <li
                          key={value}
                          className="list-inline-item"
                          onClick={(e) => frequencyFunction(e, value)}
                        >
                          <Link
                            data-date={value}
                            className={`btn btn-block ${
                              value === "1y" ? "selected" : ""
                            }`}
                          >
                            {value === "1y"
                              ? "1y"
                              : value === "2y"
                              ? "2y"
                              : value === "3y"
                              ? "3y"
                              : value === "5y"
                              ? "5y"
                              : `${value.charAt(0)}${label}`}
                          </Link>
                        </li>
                      ))}
                    </ul>
                  </div>
                  <div
                    style={{ width: "100%", height: "427px" }}
                    className=" d-block"
                  >
                    <Line
                      className="mb-5"
                      ref={chartRef}
                      data={chartData}
                      options={chartOptions}
                    />
                  </div>
                </div>
                <div className={`row ${chartStatu ? "d-none" : ""}`}>
                  <div className="col-md-12">
                    <div className="gridTable mb-2">
                      <table className="table grid w-100">
                        <thead>
                          <tr>
                            <th>{t("date")}</th>
                            <th>{t("data")}</th>
                          </tr>
                        </thead>
                        <tbody>
                          {priceGridData?.map((item, index) => (
                            <tr key={index}>
                              <td>{moment(item.date).format("DD.MM.yyyy")}</td>
                              <td>{formatNumber(parseFloat(item.value))}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PricePerformance;
